<template lang="pug">
  .select-facet
    .name {{ name }}
    autocomplete(
      :search-function="searchFunction"
      :debounce="false"
      :item-text="itemText"
      :item-value="itemValue"
      :multiple="true"
      @select="selectHandler"
    )
      template(v-slot:option="item")
        span {{ item.item[itemText] }} ({{ item.item[itemCount] }})
</template>

<script>
import Autocomplete from '@/components/RcAutocomplete.vue';
import facetMixin from '@/components/facets/facetDisplayMixin.js';

export default {
  mixins: [facetMixin],
  components: {
    Autocomplete,
  },
  methods: {
    searchFunction(search) {
      return this.options.filter(it => it[this.itemText].toLowerCase().includes(search.toLowerCase()));
    },
    selectHandler(values) {
      this.$emit('change', values);
    }
  },
}
</script>

<style lang="scss" scoped>
  .select-facet {
    .rc-autocomplete {
      margin: 1em 0;
    }
  }
</style>